import { AI_JOB_KINDS } from '@/constants/aiJobKinds';

export function thermalJobKindsEqual(left, right) {
  if (!Array.isArray(left) || !Array.isArray(right) || left.length !== right.length) {
    return false;
  }
  const kindSet = new Set(left);
  return right.every(kind => kindSet.has(kind));
}

/**
 * IR_DEFECT 선택 시 IR_LOC를 필수로 맞춘다.
 * 원본 배열은 변경하지 않는다.
 *
 * @param {string[]} selectedKinds
 * @param {{ irLocRunning?: boolean }} [options]
 * @returns {{ kinds: string[], irLocLocked: boolean, showIrLocRequiredAlert: boolean }}
 */
export function applyThermalJobKindPolicy(selectedKinds, options = {}) {
  const kinds = Array.isArray(selectedKinds) ? [...selectedKinds] : [];
  const hasDefect = kinds.includes(AI_JOB_KINDS.IR_DEFECT);
  const irLocRunning = Boolean(options.irLocRunning);

  if (hasDefect && !irLocRunning && !kinds.includes(AI_JOB_KINDS.IR_LOC)) {
    kinds.unshift(AI_JOB_KINDS.IR_LOC);
  }

  return {
    kinds,
    irLocLocked: hasDefect,
    showIrLocRequiredAlert: hasDefect
  };
}
